/* eslint-disable prettier */
/**
 * Zh-tw resource file
 */

import {
	roles,
	daySelection,
	GARoleTypeId,
	toggleCCPEntityDetail,
	readinessReportCategories,
	archiveReportQualifiedTypeId,
	natureOfEngagements,
	dashboardTabId,
	dashboardViews as dashboardViewsConstants,
	accountDesignations,
	groupRiskStatus,
	riskTypeIds
} from '../util/uiconstants';

export const labels = {
	clearFilter: "全部清除",
	canvasOversight: "Canvas Oversight",
	oversight: "Oversight",
	canvasLabel: "Canvas",
	myProjects: "My Projects",
	otherProjects: "Other Projects",
	priorProjects: 'Prior projects',
	completedProjects: "Completed projects",
	completedLabel: "完全的",
	createProject: "Create project",
	rollForward: "Roll forward",
	rollForwardLabel: "推滾",
	rollForwardTitle: "Roll forward your project",
	project: "Project",
	openProject: "Open project",
	manageUsers: 'Manage users',
	rollForwardInstructionalText: "Are you sure that you want to roll forward your project? <br> This will allow you to use your completed project as a template when creating a new project. The following information will be rolled forward: project name, organizational chart, groups and group administrators.",
	isClientUserError: "You do not have any active projects. Speak with an EY team member to be invited to a project.",
	activeProjects: "Active projects",
	myActiveProjects: "My active projects",
	otherActiveProjects: "Other active projects",
	myCompletedProjects: "My completed projects",
	myActiveProjectsPlaceholder: "You have access to the EY Canvas Oversight projects listed here. Select a project name to open it or click on a count to see details.",
	deleteProject: "Delete project",
	deleteProjectModalText: "Are you sure that you want to delete this project?<br>The project will be removed from your landing page and will no longer be accessible for any team members.",
	createButton: "Create project",
	search: "Search",
	searchEngagement: "Search engagement",
	searchEngagements: "Search engagements",
	searchEntitiesAndEngagements: "Search entities and engagements",
	searchClientList: "搜尋客戶名稱",
	noDataFound: "無資料可顯示。",
	expand: "Expand",
	collapse: "Collapse",
	more: "More",
	options: "Options",
	editProject: "Edit project",
	manageTeam: "Manage team",
	markAsCompleted: "Mark as completed",
	connectedTo: "Connected to",
	connectedClients: "Connected clients",
	connectedToClients: (count) => `${count} ${count == 1 ? 'client' : 'clients'}`,
	connectedToEngagements: (count) => `案件: ${count == 0 ? '無' : count}`,
	countEngagements: (count) => `${count} ${count === 1 ? '案件' : '案件'}`,
	connectToEngagements: (count) => `Connect ${count} ${count == 1 ? 'engagement' : 'engagements'}`,
	connectedToAccessGroups: (count) => `Connected to ${count} ${count == 1 ? 'group' : 'groups'}`,
	connectToAccessGroups: (count) => `Connect ${count} ${count == 1 ? 'group' : 'groups'}`,
	entitiesLabelForCount: (count) => `${count} ${count == 1 ? 'Entity' : 'Entities'}`,
	viewsLabelForCount: (count) => `${count} ${count == 1 ? 'View' : 'Views'}`,
	domainsLabelForCount: (count) => `${count} ${count == 1 ? 'Domain' : 'Domains'}`,
	viewsLabelWithoutCount: (count) => `${count == 1 ? 'View' : 'Views'}`,
	domainsLabelWithoutCount: (count) => `${count == 1 ? 'Domain' : 'Domains'}`,
	engagement: "engagement",
	engagementNameLabel: "Engagement Name",
	engagementPartnerLabel: "Engagement Partner",
	partnerLabel: "Partner",
	notInvited: "Not invited",
	clientNameLabel: "Client Name",
	client: "客戶",
	codeLabel: "Code",
	idLabel: "ID",
	engagements: "engagements",
	engagementsLabel: "Engagements",
	noResultsFound: "No results found.",
	submit: "Submit",
	saveAndContinue: "Save & Continue",
	savecontinue: "Save & continue",
	saveDraft: "Save as draft",
	closeLabel: "Close",
	step1: "Step 1",
	step2: "Step 2",
	step3: "Step 3",
	step4: "Step 4",
	step5: "Step 5",
	adminsNoneLabel: "無",
	domainsAllLabel: "全部",
	adminsHeaderLabel: "管理員：",
	domainsHeaderLabel: "網域：",
	moreCountLabel: '+ {0}',
	selectClient: "Select a client",
	createOrgChart: "Create org chart",
	connnectToCanvas: "Connect to EY Canvas",
	viewSummary: "View summary",
	viewLabel: "View",
	cancelLabel: "Cancel",
	required: "Required",
	filter: "filter",
	filtersWarningMessage: "超出篩選條件限制。 一次只能應用 25 個篩選條件。",
	back: "Back",
	save: "Save",
	saveClose: "Save & close",
	continue: "Continue",
	finish: "Finish",
	saveChanges: "Save changes",
	projectName: "Project name",
	projectOwners: "計畫負責人",
	addAnotherProjectOwner: "新增另一個計畫負責人",
	duplicateOwnerAdded: "重複用戶",
	step1InstructionHeader: "為您的案件輸入一個名稱新增其他案擁有者並從下面的列表中選擇一個或多個客戶以開始。",
	step1SubInstructionPart1: `您必須有訪問客戶的GIS、GFIS或Mercury代碼或EY Canvas項目的許可權，才能在下方查看客戶的姓名。您在此步驟中選擇的客戶將決定哪些EY Canvas案件可關聯到您的案件。要瞭解有關如何使用EY Canvas Oversight的更多資訊，請查看我們的{link}`,
	step2InstructionHeader: "Create an organizational chart for your project.",
	step2SubInstructionPart1: "The organizational chart should mirror how your client manages their business. It will be used to summarize data for the EY Canvas engagements that you connect to your project and to manage access for internal and external team members.",
	here: "here",
	zoomIn: "放大",
	zoomOut: "縮小",
	expandAll: "展開全部",
	collapseAll: "全部收起",
	addLabel: "新增",
	editLabel: "編輯",
	removeLabel: "移除",
	noRowsTemplateStringPart1: "You do not have access to any clients. Click",
	noRowsTemplateStringPart2: "to learn more about how to get access. ",
	noRowSelected: "Select at least one client to continue.",
	firstName: "First name",
	lastName: "Last name",
	displayLanguage: "Display language",
	numberFormat: "Number format",
	dateFormat: "Date format",
	timezone: "Time zone",
	theme: "Theme",
	chooseDisplayTheme: "Choose your default display theme.",
	light: "Light",
	dark: "Dark",
	usersettings: "User settings",
	userOptions: "User options",
	clearHoverText: "Clear",
	noFiltersAvailable: "沒有可用的篩選條件",
	dashboard: "Dashboard",
	milestones: "Milestones",
	activityFeed: "Activity feed",
	keyEvents: "Key events",
	keyEventCompletion: "Key event completion",
	canvasClientPortal: "Canvas Client Portal",
	canvasClientPortalEy: "EY Canvas Client Portal",
	groupAudit: "Group audit",
	projectManagement: "Project management",
	reporting: "Reporting",
	insights: "Insights",
	groupRiskAssessment: "集團風險評估",
	internal: "Internal",
	external: "External",
	members: "members",
	show: "Show",
	showDetails: "Show details",
	showMore: "Show more",
	showLess: "Show less",
	clientName: "Client name",
	clientsLabel: "客戶",
	clientLabel: "Client",
	source: "Source",
	code: "編號",
	accessDelegatedBy: "Access delegated by ",
	returnToPreviousStep: "Return to a previous step",
	backButtonWarning: "If you return to a previous step and make changes, your progress on this step may be impacted.<br> Select <b>Continue</b> to return to a previous step or <b>Cancel</b> to remain on this step.",
	step1SubInstructionPart3: "The clients that you select on this step will determine which EY Canvas engagements are available to connect your project to.",
	step3InstructionHeader: "Select one or more EY Canvas engagements, then drag and drop them onto your organizational chart.",
	step3InstructionPara: "The connection between EY Canvas engagements and entities on your organizational chart determines how EY Canvas data is summarized on the dashboard for your project.",
	availableLabel: "Available",
	connectedLabel: "Connected",
	milestoneSummaryView: "Milestone - summary view",
	taskCompletionByMilestone: "Task completion by milestone",
	basedOnTaskCompletition: "Based on task completion",
	scopeAndStrategy: "Scope & Strategy",
	execution: "Execution",
	conclusion: "Conclusion",
	step3ListDefaultMessage: "There are no engagements available for the client(s) that you selected on Step 1. Return to Step 1 and select a different client to continue.",
	addNewEngagementLabel: "Add new engagement",
	selectedLabel: "selected",
	moreText: "more",
	connectLabel: "Connect",
	connectEngagements: "Connected engagements",
	connectToAnEngagement: "Connect an engagement to get started.",
	connectToAnAccessGroup: "No groups have been connected.",
	tasks: "Tasks",
	organizationalChartHeading: "個體",
	groupAdministratorsLabel: "Group administrators",
	step4InstructionHeader: "Create groups for your project and connect them to one or more entities in your organizational chart.",
	step4ImportantNote: "Important note: Members of a group can view EY Canvas engagement data for the organizational chart entities that you connect the group to and any children of those entities. If you connect a group to a parent entity on your organizational chart, the group will be able to view EY Canvas engagement data for the parent entity and all of its children.",
	addAGroup: "Add a group",
	addGroup: "Add group",
	searchGroup: "Search groups",
	addNewGroupHeader: "Create a new group here.",
	editNewGroupHeader: "Edit an existing group here.",
	addNewGroupInstruction: "After your project is created, you can invite internal and external team members to this group. You have the option to add a group administrator who can also invite members to this group.",
	groupName: "Group name",
	groupAdministrators: "Group administrators (optional)",
	groupAdministratorsSubHeading: "Add a group administrator. Group administrators can invite members to your project after it is created. They cannot edit the views and domains for this group.",
	clearAllValues: "Clear",
	createGroupDashboardViews: "儀表板視圖",
	dashboardViewsSubHeading: "Select at least one view. This determines the data that members can see when they view the dashboard for your project.",
	duplicateDomain: "Duplicate domain",
	allMilestones: "All Milestones",
	someMilestonesSelected: "已選擇{0}個里程碑",
	noGroupsAdded: "No domains have been added for this project.",
	step5InstructionHeader: "Review your EY Canvas Oversight project.",
	step5SubInstruction: "If you need to make changes, select the Edit pencil to return to an earlier step. <b>Making changes to an earlier step may impact progress on later steps.</b>",
	associationNotRequired: "Association not required",
	accessGroupAlreadyAddedToParent: "You already associated one or more of the selected groups to a parent entity. If an access group is connected to a parent entity, then its members can view EY Canvas engagement data for the parent entity and all of its children. Therefore, association is not required.",
	deleteGroupInstructionalText: "Are you sure that you want to delete this group? <br> Once deleted, the operation cannot be undone. Members of the group will no longer be able to access your project.",
	deleteGroup: "Delete group",
	removeMember: "Remove a member",
	removeMemberTitle: "Are you sure that you want to remove this team member? If the member belongs to multiple groups, then they will be removed from all of the groups listed here and may no longer be able to access this project. If you only want to remove the member from a single group, then select the <b>Edit</b> option instead.",
	teamMember: "Team member",
	clientNameLbl: "Clients",
	help: "協助",

	//Org char left rail
	filters: "Filters",
	countEngagementSelected: "{0} of {1} engagements selected",
	of: "{num} 個",
	entityName: "Entity name",
	enterEntityName: "Enter name here",
	projectOwner: "計畫負責人",
	role: 'Role',
	domains: "Domains (optional)",
	domainSubHeading: "Add at least one domain if external team members will be invited to this group. Domain refers to the characters after the @ symbol in an email address. To add an external team member, they must have a valid domain for this group.",
	addAdministrator: "Add a group administrator",
	addNewDomain: "Add a new domain",
	addExistingDomain: "Add an existing domain",
	placeholderStep3NoEngagementMessage: "There are no engagements available for the client(s) that you selected on Step 1. Return to Step 1 and select a different client to continue.",
	placeholderStep3NoConnectedEngagementMessage: "There are no connected engagements yet.",
	placeholderStep3AllEngagementsConnected: "All available engagements are connected to your project.",
	placeholderStep4NoConnectedGroupMessage: "There are no connected groups yet.",
	domainName: "Domain name",
	engagementLabel: "Engagement",
	start: "Start",
	end: "End",
	suggestedEnd: "Suggested end",
	status: "Status",
	thereIsNoDataToDisplay: "There is no data to display.",
	selectadditionalEntitiesToContinue: "Select additional entities to continue.",
	comingSoonToDisplay: "組成個體狀態即將上線",
	checkForUpdatesToDisplay: "請於接下來幾週回來檢查是否有更新。",
	userSearchPlaceholder: "Enter name or email and press Enter to see results.",
	userSearchPlaceholderForExternal: "Enter email and press enter to see results.",
	partnerInChargeInvitedToTheEngagement: "Partner in charge invited to the engagement",
	partnerInChargeSignedOffOnCraSummary: "Partner in charge signed off on CRA summary",
	eqrSignedOffOnCraSummary: "EQR signed off on CRA summary",
	partnerInChargeSignedOffOnAuditPlan: "Partner in charge signed off on Audit plan",
	picInvited: "已邀請 PIC",
	picSignOffCRA: "PIC 於CRA簽核",
	picSignOffAuditPlan: "PIC 於查核計畫簽核",
	eqrSingOffCRA: "EQR 於CRA簽核",
	overdue: "overdue",
	outOf: "out of",
	edit: "Edit",
	remove: "Remove",
	add: "Add",
	admin: "Admins",
	views: "Views",
	domainLabel: "domain",
	domainslabel: 'Domains',
	viewLabelText: "view",
	viewsLabelText: "views",
	administrators: "Administrators",
	none: "None",
	organizationChart: "Organizational Chart",
	invalidDomainName: "Invalid domain name",
	lastRefreshed: "Last refreshed",
	lastRefreshedActivityFeed: 'Activity feed data last refreshed',
	lastRefreshedReconciliation: "上次更新的調節資料",
	quickFilter: "Quick filter",
	notApplied: "Not applied",
	quickFilterInput: "Quick filter name",
	quickFilterSubHeaderText: "When you are done, you can apply the quick filter to refine the entities that you would like to view data for without having to individually select each one.",
	createFilterTrigger: "Create new filter",
	createFilterTitle: "Create new quick filter",
	createFilterButton: "Create quick filter",
	createFilterHeaderText: "Select one or more organizational chart entities to create a quick filter.",
	createFilterSubHeaderText: "When you are done, you can apply the quick filter to refine the entities that you would like to view data for without having to individually select each one.",
	editFilterTitle: "Edit quick filter",
	editFilterHeaderText: "Edit or delete a quick filter.",
	editFilterIconTitleTip: "Edit",
	oneRequired: "At least one selection is required.",
	noFiltersCreatedTitle: "No quick filters created yet.",
	noFiltersCreatedSubTitle: "Create a quick filter to get started.",
	clear: "Clear",
	completionRange: "Completion range",
	engagementCount: "Engagement count",
	clickOnAVisualBelowToFilterTheEngagementList: "點擊下面的視覺圖形以篩選案件清單。",
	organizationalChartTooltip: "選擇組織結構圖以從您的Oversight Project中編輯或移除個體。",
	organizationalChart: "組織結構圖",

	//Task status chart labels
	open: "Open",
	inProgress: "進行中",
	inReview: "In review",
	completeUpperCase: "Complete",
	taskStatusOverdue: "Overdue",
	noDataForSelections: "There is no data available for your selections.",
	selectOneOrMoreMilestones: "Select one or more different milestones to continue.",
	milestoneDetailTitle: "Milestones - detail",
	taskStatusByMilestone: "Task status by milestone",
	milestoneDetailSubtitle: "Based on task status",
	basedOnAllTasksForTheSelectedMilestone: "Based on all tasks for the selected milestone(s)",
	totalTasks: "total tasks",
	noneSelected: "None selected",
	nameOrEmail: "Name or email",
	remove: "Remove",
	milestonesTooltipText: "Audit progress by milestone",
	canvasClientPortalTooltipText: "Request status, including coming due, overdue and returned items",
	groudAuditTooltipText: "Primary and component team status, including returned and overdue items",
	projectManagementTooltipText: 'Status of review notes and assignments, including overdue items. This view will not be visible to clients.',
	insightsTootipText: "Comparison of risks, substantive procedures, control strategy and findings between primary and component teams. This view will not be visible to clients.",
	reportTootipText: "Report readiness, modification and task completion status by country",
	taskStatusComplete: "Task status - Complete",
	taskStatusInreview: "Task status - In review",
	taskStatusInprogress: "Task status - In progress",
	taskStatusOpen: "Task status - Open",

	//Review Notes chart labels
	reviewNotesByStatusTitle: "所有複核註記",
	byStatus: "By status",
	totalNotes: "註記總計",
	totalNotesLabel: "註記總計",
	openNotes: "未解決註記",
	byPriority: "By priority",
	cleared: "Cleared",
	closed: "Closed",
	low: "Low",
	medium: "Medium",
	high: "High",
	critical: "Critical",
	notesTableTooltipContent: "未解決狀態之註記",

	// Group audit
	groupAuditTotalForms: "Total forms",
	groupAuditNotSent: "Not sent",
	groupAuditUnlinked: "Unlinked",
	totalTasksCapitalized: "Total tasks",
	primary: "Primary",
	component: "Component",

	//Bar chart
	are: "are",
	complete: "complete",
	noMilestoneDataForSelection: "There is no milestone data to display for this audit phase.",
	selectDifferentAuditPhase: "Select a different audit phase or select additional entities to continue.",

	//Delegate
	delegateInstruction: "Delegate access to your other team member so they can create projects on your behalf. Enter a team member's name or email address to get started. Your delegates will have access to all of your clients.",

	delegateAccess: "Manage delegates",
	addAnother: 'Add delegates',
	hideMyDelegate: "Hide my delegates",
	showMyDelegate: "Show my delegates",
	noRecord: "No results found",
	duplicateUser: "Delegate already added",
	duplicateUserMessage: "使用者已新增",
	addDelegates: "Add delegates",
	delegateTo: "Delegated to",
	delegateFrom: "Delegated from",
	delegateToMsg: "You have not delegated your access to any team members.",
	delegateFromMsg: "No team members have delegated their access to you.",

	// Project dashboard left rail
	searchFilterPlaceholder: "Search filters",
	searchEntitiesPlaceholder: "Search entities",
	outOfEngagements: "<b>{0}</b> out of <b>{1}</b> engagements",
	engagementCompletedBasedOnTaskCompletion: "<b>{0}</b> engagement is <b>{1}</b> complete based on task completion",
	engagementsCompletedBasedOnTaskCompletion: "<b>{0}</b> engagements have <b>{1}</b> complete based on task completion",
	engagementCompletedBasedOnTaskCompletionReporting: "<b>{0}</b> engagement has completed <b>{1}</b> of tasks",
	engagementsCompletedBasedOnTaskCompletionReporting: "<b>{0}</b> engagements have completed <b>{1}</b> of tasks",
	engagementCompletedBasedOnTaskCompletionMilestone: "<b>{0}</b> engagement has completed <b>{1}</b> of tasks for this milestone",
	engagementsCompletedBasedOnTaskCompletionMilestone: "<b>{0}</b> engagements have completed <b>{1}</b> of tasks for this milestone",
	reportReleaseDate: "Report release date",
	partnerInvited: "Partner invited",
	picSignoffOnCra: "PIC sign-off on CRA",
	eqrSignoffOnCra: "EQR sign-off on CRA",
	picSignoffOnAuditPlan: "PIC sign-off on Audit plan",
	overdueLabel: "Overdue",

	//Team members
	teamMembersTitle: "Team members",
	membersTitle: "Members",
	eyContactsTitle: "EY contacts",
	allMembersLabel: "All members",
	internalMembersLabel: "Internal members",
	externalMembersLabel: "External members",
	groupsTitle: "My groups",
	projectOwnersTitle: "Project owners",
	projectOwnersLabel: "計畫負責人",
	projectOwnerLabel: "計畫負責人",

	//CCP
	summary: "Summary",
	requestsByStatus: "Requests by status",
	totalRequests: "total requests",
	totalRequestsTitle: "Total requests",
	receivedByEy: "Received by EY",
	acceptedByEy: "Accepted by EY",
	outstandingByEy: "Outstanding",
	returned: "Returned",
	receivedByEyOnTime: "Received by EY on time",
	averageDaysOverdue: "Average days overdue",
	outOfReceivedAndAccepted: "<b>{0}</b> out of <b>{1}</b> received and accepted requests",
	outOfStandingRequests: "<b>{0}</b> out of <b>{1}</b> outstanding requests",
	outOfAverageDaysOverdue: "<b>{0}</b> out of <b>{1}</b> outstanding requests",
	draftRequests: "{0} draft requests",
	noResultMessageHeader: "There is no data to display. Select additional entities to continue.",
	noResultMessageSubHeader: '',
	members: "members",
	memberLabel: "member",
	adminLabel: "Admin",
	projectOwnerLabel: "Project owner",
	viewsLabel: "views",
	metrics: "Metrics",
	yes: "Yes",
	no: "No",
	emptyMessageAvailableGroup: "No groups have been created yet. <br> Select <b>Add a group</b> to get started.",
	thereIsNoDataToDisplayForThisEntity: "There is no data to display for this entity.",
	typeLabel: "Type",
	groupsLabel: "Groups",
	group: "Group",
	entitiesLabels: "Entities",
	entityLabel: 'Entity',
	nameLabel: "Name",
	searchTeamMembers: "Search team members",
	notSelectedLabel: "Not selected",
	entitiesLabel: "Entities",
	noDataAvailableLabel: "No data available.",
	delete: "Delete",
	deleted: "已刪除",
	addAMember: "Add a member",
	addMemberHeaderText: "Add a new member to one or more groups for your project.",
	teamMemberInformation: "Team member information",
	teamMemberNote: "Enter the name or email for the internal or external team member who you wish to add to the selected groups. Press the Enter key to see results.",
	selectGroupNote: "Select at least one group. Group members can view EY Canvas engagement data for all of the organizational chart entities that their groups are connected to, as well as any children of those entities.",
	inviteAndClose: "Invite & close",
	inviteAndAddAnother: "Invite & add another",
	contacts: "Contacts",
	email: "Email",
	emailAll: "Email all",
	contactTeam: "Contact team",
	emptyMessage: "There are no contacts available for this engagement.",
	comingDue: "Coming due",
	tomorrow: "Tomorrow",
	next3days: "Next 3 days",
	next5days: "Next 5 days",
	next10days: "Next 10 days",
	next30days: "Next 30 days",
	comingDueNext5days: "Coming due (next 5 days)",
	entityDetails: "Entity details",
	requestsByEntity: "Requests by entity",
	basedOnTheSelectedCategory: "Based on the selected category",
	requestCount: "Request count",
	selectedDay: "Selected day",
	editMember: "Edit member",
	editMemberHeaderText: "Edit the groups that the selected team member has access to.",
	editaGroup: "Edit group",
	editAGroupHere: "Edit a group here",
	selectAnotherFrame: "Select another time frame to view data.",
	emptyFrameShort: "Select additional entities to continue.",
	emptyFrame: "Select additional entities or a different time frame to continue.",
	editMemberHeaderText: "Edit the groups that the selected team member has access to.",
	confirm: "Confirm",
	markCompleteModalInstrTextPart1: "Are you sure that you want to complete this project?",
	markCompleteModalInstrTextPart2: "Once you take this action, it cannot be undone. Completed projects can be rolled forward and used as a template when creating a new project.",
	firstPage: "First page",
	lastPage: "Last page",
	nextPage: "Next page",
	prevPage: "Previous page",

	// Add Tag
	keyContacts: "主要聯絡人",
	customTags: "自定義標籤",

	// Manage Tags
	manageTagInstructional: "在此處建立新的自定義標籤。 您還可以編輯和刪除現有的自定義標籤。 標記聯絡人使您可以靈活地管理 EY Canvas Oversight project中的聯絡人。",
	emptyCustomTagsList: "尚未建立自定義標籤。",
	manageTagTitle: "管理自定義標籤",
	manageTagLinkButton: "管理標籤",
	color: "顏色",
	tagName: "名稱",
	tagDelete: "刪除",
	tagCreate: "建立新標籤",
	customTagsHeader: "自定義標籤",

	//preparer assignment tile
	totalPreparerAssignments: "total preparer assignments",
	inprogress: "In progress",
	preparerAssignments: "Preparer assignments",
	byAssignmentStatus: "By assignment status",
	taskWithoutPreparerAssignments: "task without preparer assignments",
	tasksWithoutPreparerAssignments: "tasks without preparer assignments",
	preparerFilterTitle: "編製者",

	// reviewer assignment tile
	totalReviewerAssignments: "total reviewer assignments",
	taskWithoutReviewerAssignments: "task without reviewer assignments",
	tasksWithoutReviewerAssignments: "tasks without reviewer assignments",
	reviewerFilterTitle: "複核者",

	assignments: "Assignments",
	notes: "註記",
	preparerNotAssigned: "Preparer not assigned",
	reviewerAssignments: "Reviewer assignments",
	reviewerNotAssigned: "Reviewer not assigned",
	basedOnPreparerAssignments: "Based on preparer assignments",
	basedOnPreparerAssignmentsOpenAndInProgress: "Based on preparer assignments with Open and In Progress status",
	basedOnReviewerAssignments: "Based on reviewer assignments",
	basedOnReviewerAssignmentsOpenAndInProgress: "Based on reviewer assignments with Open and In Progress status",

	statusOpen: "Status - Open",
	statusInProgress: "Status - In-progress",
	statusClosed: "Status - Closed",
	byPriorityLow: "By priority - Low",
	byPriotityMedium: "By priority - Medium",
	byPriorityHigh: "By priority - High",
	byPriorityCritical: "By priority - Critical",

	findingsLabel: "Findings",
	riskLabel: "Risks",
	digitalAuditLabel: "Digital audit",
	digitalAuditStrategy: "Digital audit strategy",
	byDigitalAuditTypeLabel: "By digital audit strategy",
	basedOnProfileSelection: "Based on profile selection",
	basedOnSelectionArchiveForm: "Based on selection on the archive form",
	MisstatementsByType: "Misstatements by type",
	DeficienciesBySeverity: "Deficiencies by severity",
	MisstatementsLabel: "Misstatements",
	DeficienciesLabel: "Deficiencies",
	primarTeamDeficiencyHeader: "Primary teams - {0}",
	componentRegionalTeamDeficiencyHeader: "Regional and component teams - {0}",
	auditTileHeaderTextPrimary: "Primary teams - {0}",
	componentRegionalTeamHeader: "Regional and component teams - {0}",
	allTeamDeficiencyHeader: "All engagements - {0}",
	primarTeamMisstatementHeader: "Primary teams - {0}",
	componentRegionalTeamMisstatementHeader: "Regional and component teams - {0}",
	allTeamMisstatementHeader: "All engagements - {0}",
	deficiencyLabel: "Deficiency",
	inherenRisktLabel: 'Risk of material misstatement',
	significantRiskLabel: "Significant",
	fraudRiskLabel: "Fraud",
	significantDeficiencyLabel: "Significant deficiency",
	materialWeaknessLabel: "Material weakness",
	factualLabel: "Factual",
	projectedLabel: "Projected",
	judgmentalLabel: "Judgmental",
	reclassificationLabel: "Reclassification",
	totalDeficiencyLabel: "total deficiency",
	totalRiskLabel: "total risk",
	totalRisksLabel: "total risks",
	totalDeficienciesLabel: "total deficiencies",
	totalMisstatementLabel: "total misstatement",
	totalMisstatementsLabel: "total misstatements",
	allEngagementHeader: "All engagements - {0}",
	noAuditSightGroupData: "<b>No group audit data to display.</b> <br> Select <b> All </b> from the toggle to see summarized data.",
	noAuditTileDataPlaceholder: "There is no data to display. Select additional entities to continue.",
	openReviewNotes: "未解決複核註記",
	byPriorityLevel: "By priority",
	risks: "Risks",
	groupRoleLabel: "團隊角色",
	totalRisks: "Total risks",
	byType: "By type",
	inherent: 'Risk of material misstatement',
	significant: "Significant",
	fraud: "Fraud",
	strategy: "Strategy",
	notApplicable: "Not applicable",
	customizableTable: "Customize table",
	selectUpToOptionHeader: "Select up to {0} options",
	selectUpToThreeOptionHeader: "Select up to three options",
	selectUpToFourOptionHeader: "Select up to four options",
	psps: "PSPs",
	osps: "OSPs",
	hxpsps: "HxPSPs",
	totalSubstantiveProcedures: "total substantive procedures",
	totalSubstantiveProcedure: "total substantive procedures",
	totalITControls: " total ITGCs and ITSPs",
	totalITControl: "total ITGC and ITSP",
	testing: "Testing",
	nonTesting: "Not testing",
	auditStrategy: "Audit strategy",
	totalControls: "total controls",
	totalControl: "total control",
	removeProject: "Remove project",
	removeProjectInstructionalText: "Are you sure that you want to remove the following project from your list of active projects? <br>If you remove the project, you will no longer be able to access it.",
	substantiveProcedures: "Substantive",
	controls: "Controls",
	itlabel: "IT",

	//delegates removed
	userDelTitle: "My delegates",
	delTitleDetail: "You have delegated your access to the team members listed here. Your delegates have access to all clients that you have access to.",
	delElseMsg: "You have not added any delegates yet.",
	delegateTitle: "Remove a delegate",
	delegateMember: "Delegated",
	deleteMessage: "Are you sure that you want to remove this delegate?<br/> Once removed, they will no longer be able to create projects on your behalf.",

	//Advanced filters.
	advancedFilters: "Advanced filters",
	selectAll: "Select all",
	deselectAll: "Deselect all",
	applyFilters: "Apply filters",
	region: "Region",
	country: "Country",
	city: "City",
	state: "State",
	advancedFiltersInstructionalText: "Select the entities for which you would like to view engagement data.",
	advancedFiltersInstructionalTextLine2: "Entities that you do not have access to appear disabled. Speak with a Group Administrator if you require access.",
	engagementsSelected: "engagement(s) selected",
	filterYes: "是",
	filterNo: "否",

	//Group Audit
	pendingResponse: "Pending response",
	primaryTileTitle: "Primary team status",
	reportingFormStatus: "Reporting form status",
	reportingForm: "報表表單",
	summarizedForPrimaryTeams: "Summarized for primary teams",
	primaryTileSubtitle: "group reporting forms sent",
	received: "Received",
	dueToPrimaryTeam: "Due to primary team",
	sentToPrimaryTeam: "Sent to primary team",
	evidencePending: "Evidence pending",
	evidenceComplete: "Evidence complete",
	componentTileTitle: "Component team status",
	componentTaskStatus: "Component task status",
	componentTask: "組成個體任務",
	comingsoonTaskStatus: "Coming soon",
	summarizedForComponentTeams: "Summarized for component teams",
	componentTileSubtitle: "group audit tasks received",
	unlinkedTask: "unlinked task",
	unlinkedTasks: "unlinked tasks",

	//Group Risk Assessment
	groupRiskAssessmentTitle: "風險",
	groupRiskSummaryTitle: "集團風險評估",

	// Reporting
	reportModifications: "Report modifications",
	byReportType: "By report type",
	notSelected: "Not selected",
	unmodified: "Unmodified",
	modified: "Modified",
	reports: "Reports",
	opinions: "意見",
	modifiedReports: "Modified reports",
	modifiedOpinions: "Modified opinions",
	adverse: "Adverse",
	disclaimer: "Disclaimer",
	qualification: "Qualification",
	qualified: "Qualified",
	engagementReportTooltip: "Only engagements with report dates on or before the current date are summarized here. All engagements are displayed in the table below.",
	geography: "Geography",
	standars: "Standards",
	gaap: "GAAP",
	gaapUs: "GAAP US",
	ifrs: "IFRS",
	other: "Other",
	yearEndDate: "Year-end date",
	endDateOfPeriodCovered: "End date of period covered",
	reportDate: "Report date",
	archiveDeadline: "Archive deadline",
	reportType: "Report type",
	opinionType: "Opinion type",
	taskStatus: "Task status",
	exportData: "Export data",
	exportToExcel: "匯出",
	orgChartEntity: "Org chart entity",
	engagementId: "Engagement ID",
	contactName: "Contact name",
	contactEmail: "Contact email",
	statusInherent: 'By Type - Risk of material misstatement',
	statusSignificant: "By Type - Significant",
	statusFraud: "By Type - Fraud",
	substantivePSPs: "Substantive - PSPs",
	substantiveOSPs: "Substantive - OSPs",
	substantiveHxPSPs: "Substantive - HxPSPs",
	controlsTesting: "Controls - testing",
	controlsNonTesting: "Controls - Non testing",
	iTTesting: "IT - testing",
	iTNonTesting: "IT - Non testing",
	misstatementsFactual: "Misstatements - Factual",
	misstatementsProjected: "Misstatements - Projected",
	misstatementsJudgmental: "Misstatements - Judgmental",
	misstatementsReclassification: "Misstatements - Reclassification",
	deficienciesDeficiency: "Deficiencies - Deficiency",
	deficienciesSignificantdeficiency: "Deficiencies - Significant deficiency",
	deficienciesMaterialweakness: "Deficiencies - Material weakness",
	statusComplete: "Status - Complete",
	statusInReview: "Status - In review",
	statusInProgress: "狀態 - 進行中",
	statusOpen: "Status - Open",
	statusNotSent: "Status - Not sent",
	statusReturned: "Status - Returned",
	statusDocumentationPending: "Status - Documentation pending",
	statusDocumentationComplete: "Status - Documentation complete",
	statusReceivedbyEY: "Status - Received by EY",
	statusAcceptedbyEY: "Status - Accepted by EY",
	statusOutstanding: "Status - Outstanding",
	noCompletedProjectsMessagePart1: "You do not have any completed projects.",
	noCompletedProjectsMessagePart2: "If you are a project owner, then you can mark a project as completed. Completed projects can be rolled forward and used as a template when creating a new project.",
	noCompletedProjectsMessage: "You do not have any completed projects. <br>If you are a project owner, you may mark the project completed. Completed projects can be rolled forward and used as a template when creating a new project.",
	requests: "Requests",

	//Reporting readiness report
	week: "week",
	weeks: "weeks",
	readinessReportTitle: "Report readiness",
	taskCompletionByEngagement: "Task completion by engagement",
	readinessLegendTitle: "Proximity to report date",
	basedOnReportDateProximityForEachEngagement: "Based on report date proximity for each engagement",

	//ReportCompletion
	taskCompletionStatus: "Task completion status",
	taskCompletionByLocation: "Task completion by location",
	basedOnCompletedTasksForEachEngagement: "Based on completed tasks for each engagement",
	byGeography: "By geography",
	taskCompletion: "Task completion",
	completedTasks: "completed tasks",

	engagementArchived: "This engagement has been archived. Data is no longer available.",
	externalUsersNoActiveProjMessage: "You do not have any active projects. Speak with an EY team member to gain access.",

	//Error Messages
	networkErrorMessage: "The application network is experiencing an error. Refresh the page and try again later. Contact the Help Desk if the error persists.",
	genericErrorMessage: "The selected operation could not be completed at this time. Refresh the page and try again. Contact the Help Desk if the error persists.",
	otherProjectPlaceholder: "Your EY Canvas engagements are connected to the EY Canvas Oversight projects listed here. You do not have access to these projects. Speak with a project owner or group administrator to gain access.",
	noProjectsAvailable: "No projects available.",
	completedProjectPlaceholder: "Your completed EY Canvas Oversight projects are listed here. Select the <b> Roll forward </b> option to use your completed project as a template when creating a new project.",
	completedNotProjectPlaceholder: "You do not have any completed projects. <br>If you are a project owner, you may mark the project completed. Completed projects can be rolled forward and used as a template when creating a new project.",

	//Log out and time out modal
	logoutModalTitle: "Automatic logout for your protection",
	sessionTimerMsgLine1: "Due to inactivity, your current work session is about to expire.",
	sessionTimerMsgLine2: "For your security, EY Canvas Oversight sessions end automatically after 30 minutes of inactivity.",
	sessionTimerMsgLine3: "Your current session will expire in {0} minutes.",
	sessionTimerMsgLine4: "If you wish to remain logged in, please click",
	modalContinueButton: "<b>Continue</b>",
	modalLogoutButton: "Log out",
	modalCloseButton: "Close",
	countryNotAvailable: "Country not available",
	regionNotAvailable: "Region not available",
	notAvailable: "Not available",
	signout: 'Sign out',
	engagementTypeNotAvailable: "Engagement type not available",

	// Admin portal
	administration: 'Administration',
	mainPageInstructionalText: 'Welcome to the EY Canvas Oversight Administrative Portal',
	manageProjectsFormatted: 'Manage <br />projects',
	manageUsersFomatted: 'Manage <br />users',
	manageAdminsFormatted: 'Manage <br />Oversight admins',
	homeLabel: 'Home',
	userNotFoundError: 'User not found.',
	manageUsersInstructionalText: 'Search for a user by entering their GUI',
	selectRole: 'Select role',
	role: 'Role',

	//Manage User
	manageUsersTitle: 'Manage users',
	otherProjectsTabTitle: 'Other projects',
	validGuiErrorMsg: 'Enter a valid GUI',
	accessibleProjects: 'Accessible projects',
	delegates: 'Delegates',
	projectID: 'Project ID',
	projectStatus: 'Project status',
	gui: 'GUI',
	emailAddress: 'Email address',
	userRole: 'User role',
	userID: 'User ID',
	noResultMessage: 'No results match the search criteria.',
	noResultFound: 'No records found.',
	userDetails: 'User details',
	active: 'Active',
	inActive: 'Inactive',
	manageAdmins: 'Manage EY Canvas Oversight administrators',
	manageAdminsInstructionalText: 'All EY Canvas Oversight administrators are listed below.  You can edit the roles for an administrator, add, and remove administrators.',
	adminReader: 'Application admin reader',
	adminWriter: 'Application admin writer',
	superAdmin: 'Application super admin',
	revertChanges: 'Revert changes',
	unSavedChanges: 'Unsaved changes',
	unSavedChangesMessage: 'You have unsaved changes that will be lost if you continue. <br/> Select <b>Confirm</b> to continue. Select <b>Cancel</b> to return to the underlying page and save your changes.',
	addNewAdmin: 'Add new administrator',
	addEYContactInstructions: 'Enter a name or email address and press Enter to see results.  Select a role to add a new Oversight administrator.',

	// ManageProjects
	orgChartEntities: 'Org chart entities',
	manageProjectsInstructionalText: 'Search for a project by entering the project ID.',
	projectDetails: 'Project details',
	parentEntity: 'Parent entity',
	connectedGroups: 'Connected groups',
	validProjectIDError: 'Enter a valid project ID',
	addNewMember: "加入成員",
	adminAddMemberInstructionalText: "搜尋使用者並為其選擇應加入的群組。",
	currentApplication: "目前應用",

	//Software Update
	softwareUpdate: "軟體更新",
	updateNow: "現在更新",
	updateMsg: "EY Canvas Oversight 軟體更新已可使用。 選擇立即更新以下載並安裝更新。頁面將被重新整理。",

	//ContactDB
	placeholderForSearch: "搜尋",
	contactClearAll: "全部清除",
	contactShowMoreFilters: "更多的",
	contactListFilter: "訪問聯絡人列表",
	dashboardAccessFilter: "訪問儀表板",
	groupRoleFilter: "團隊角色",
	tagFilter: "標籤",
	countryFilter: "國家",
	serviceLineFilter: "服務線",
	typeFilter: "類型",
	roleFilter: "角色",
	dashboardAccess: "訪問儀表板",
	contactList: "聯絡人列表",
	noEntitiesMessage1: "沒有可顯示的資料。",
	noEntitiesMessage2: "選擇其他個體以繼續。",
	noContacts: "該個體沒有聯絡人。",
	engagementsContacts: "案件",
	manuallyAdded: "手動新增",
	dashboardViews: "視圖",
	columnName: "名稱",
	columnEmail: "電子郵件",
	columnEngagement: "案件",
	columnType: "類型",
	columnRole: "角色",
	columnServiceLine: "服務線",
	columnDashboard: "訪問儀表板",
	columnDashboardView: "儀表板檢視",
	columnContactList: "訪問聯絡人列表",
	columnTags: "標籤",
	columnEntity: "個體",
	noResults: "沒有找到結果",
	noResultsAvailable: "沒有可用的資料。",
	searchContacts: "搜尋聯絡人",
	selectedContacts: "選擇的聯絡人",
	tag: "標籤",
	manageAccess: "管理訪問",
	formLengthMessage: "文字不能超過 {number} 個字符。",
	viewMoreColumns: "檢視更多欄位",
	projectOwnerBadge: "計畫負責人",
	entityAdminBadge: "實體管理員",
	eyTeam: "安永團隊",
	clientTeam: "客戶團隊",
	userProfile: "使用者資料",
	columnGroupRiskAssessment: "Access to group risk assessment",
	externalUserDenyMessage: 'External users cannot be granted access to the Group risk assessment module.',
	//ContactDB - Toolbar
	toolbarAddContact: "Add contact",
	toolbarAccessLog: "Access log",
	toolbarMessageLog: "Message log",
	toolbarCustomizeTable: "Customize table",
	toolbarExportData: "Export data",
	toolbarManageAccess: "Manage access",
	toolbarDefineAttributes: "Define attributes",
	toolbarGenerateMessage: "Generate message",
	toolbarTags: "標籤",
	toolbarRemove: "移除",

	//ContactDB - Add Contact Modal
	addContactLabel: "新增聯絡人",
	addContactTitle: "新增聯絡人",
	addContactInstructional: "向您的 EY Canvas Oversight 案件新增一個或多個聯絡人。若您要新增的聯絡人需要訪問儀錶板或聯絡人列表，您可以在此處授予他們訪問的權限。",
	columnEntities: "個體",
	noEntities: "無",
	duplicatedUser: "已被加入為聯絡人。 您可以從聯絡人清單管理他們的存取權限。",
	accessToDashboard: "訪問儀表板",
	dashBoardsViews: "Dashboard Access and Views",
	placeholderEntities: "個體",
	placeholderAccess: "訪問",
	placeholderAttributes: "屬性",
	placeholderTags: "標籤",
	projectOwnerAccessLabel: "Project Owner access",
	entityAdminAccessLabel: "Entity Admin access",
	accessToContactListLabel: "訪問聯絡人列表",
	saveContactLabel: "儲存",
	cancelContactLabel: "取消",
	noContactsAdded: "尚未新增聯絡人。",
	noCustomColumns: "尚未為您的項目建立自定義欄。",
	toggleContactYes: "是",
	toggleContactNo: "否",
	mustSelectOneEntity: "您必須至少選擇一個個體才能繼續。",
	mustSelectOneView: "為所有被授權訪問EY Canvas Oversight 儀表板的聯絡人至少選擇一個視圖。",
	mustBeOnwerOrAdministrator: "您必須為計畫負責人或個體管理員才能執行此操作。請更新所選個體以繼續。",
	cannotEditAccessForProjectOwners: "您無法編輯計畫負責人的訪問權限：{list}",
	attributesLabel: "屬性",
	externalUserDomainMismatch: "一個或多個所選定個體不允許網域。 在個體設定流程中新增所需的網域，然後重試。",
	projectOwnerAccessToogleInfo: "A Project owner has full permissions for an EY Oversight project.",
	entityAdminAccessToogleInfo: "An Entity admin has Entity specific permissions to perform administrative tasks, as needed.",

	//ContactDB-CustomizeTable Modal
	customizeTableModal: "自定義表格",
	InstructionalTextCustomizeTableModal: "選擇您要查看的列。",
	cancelCustomizeTable: "取消",
	saveCustomizeTable: "儲存",
	tooltipCustomizeTable: "自定義表格",
	standardColumns: "標準欄",
	customColumns: "自定義欄",
	closeTitleModal: "關閉",
	addCustomColumn: "新增自定義欄",
	editCustomColum: "編輯自定義欄",
	addCustomColumnLegend: "自定義列允許您獲取和管理有關聯絡人的其他屬性。 您最多可以為計畫建立五個自定義欄。 建立欄後，您可以選擇一個或多個聯絡人並定義屬性。 若刪除自定義欄，聯絡人的屬性也將被刪除。",
	deleteCustomColumnLegend: "選擇<b>刪除</b>圖標以刪除自定義列。 若您繼續，那麼它將不再可用於您的計畫。 您之前應用於聯絡人的任何屬性也將被刪除。",
	customColumnName: "欄位名稱",
	attribute: "屬性",
	attributes1to5: "屬性（1-5）",
	visibleToExternal: "對外部聯絡人可見",
	noCustomColumnMsg: 'No custom column added',

	//ContactDB - Add Contact Modal
	filterTooltip: "篩選",
	searchTitletip: "搜尋",
	addExternalContactColumnName: "姓名",
	addExternalContactColumnDomain: "網域",
	confirmDomain: "確認網域",

	//ContactDB - Profile Modal
	profileModalTitle: "基本資料",
	profileModalAccessSection: "訪問",
	profileModalCustomAttributesSection: "自定義屬性",
	profileModalDashboardSection: "儀表板總覽",

	//ContactDB - Generate Message
	selectMessageRecipients: "選擇消息收件人",
	notification: "通知",
	generateMessage: "產生訊息",
	gmInstructionalText: "向您選擇的聯絡人發送電子郵件或通知。 通知只能發送給內部聯絡人。 可以向內部和外部聯絡人發送電子郵件。",
	messageType: "訊息類型",
	messageRecipient: "消息收件人",
	selectContactsNow: "立即選擇聯絡人",
	useSelectedContacts: "使用所選的聯絡人",
	moreFilters: "+ 更多篩選條件",
	countries: "國家",
	groupRoles: "集團角色",
	groupRole: "Group role",
	roles: "角色",
	role: 'Role',
	serviceLines: "服務線",
	serviceLine: "服務線",
	contatcs: "聯絡人",
	singularContact: "聯絡人",
	singularEngagement: "案件",
	allContact: "所有聯絡人",
	allEntitles: "所有個體",
	allCountries: "所有國家",
	allGroupRoles: "所有集團角色",
	allEngagements: "所有案件",
	allServicesLines: "所有服務線",
	allRoles: "所有角色",
	subject: "主題",
	removeTooltip: "移除",
	fromEntity: "來自個體",
	fromEngagement: "來自案件",
	notificationMessage: "通知訊息",
	linkLabel: "連結標籤（選擇性的）",
	link: "連結（選擇性的）",
	fromEntityNotification: "來自個體",
	mustSelectOne: "您必須至少選擇一位聯絡人才能繼續。",
	emailSentMsg: "已為所選聯絡人產生一封電子郵件。",
	notificationSentMsg: "通知已發送給選定的聯絡人。",
	messageFrom: "訊息來自",
	duplicateMessage: "重覆訊息",
	someEntities: '{0} entities selected',

	//ContactDB - Message Log
	messageLogInstruction: "查看您的個體發送的訊息列表。若您需要發送後續訊息，您可以選擇複製以前的訊息。",
	messageLogTitle: "留言記錄",
	today: "今天",
	yesterday: "昨天",
	thisWeek: "本週",
	lastWeek: "上週",
	twoWeeksAgo: "兩週前",
	older: "較舊的",
	notificationTo: "通知給",
	emailTo: "發郵件給",
	sentBy: "發送由",
	from: "自",
	date: "日期",
	time: "時間",
	subject: "主題",
	multiContatcsLowerCase: "聯絡人",
	singleContactLowerCase: "聯絡人",
	seeMore: "看更多",
	seeLess: "看更少",
	messageLogEmptyMessage: "尚未發送任何訊息。",
	messageLogFileExported: "留言記錄",
	typeColumnToExportToExcel: "類型",
	sentByColumnToExportToExcel: "由...發送",
	fromColumnToExportToExcel: "從",
	dateColumnToExportToExcel: "日期",
	timeColumnToExportToExcel: "時間",
	subjectColumnToExportToExcel: "主題",
	contactsColumnToExportToExcel: "聯絡人",
	emailExportToExcel: "電子郵件",
	notificationExportToExcel: "通知",

	//ContactDB - Access Log
	accessLog: "訪問紀錄",
	accessLogInstructional: "查看下方顯示的團隊成員並決定是將他們新增為聯絡人或將其移除。",
	addAll: "新增所有",
	removeAll: "移除所有",
	ignoreAll: "忽略所有",
	contactsToAddEmpty: "目前無要新增的潛在聯絡人。",
	contactsToRemoveEmpty: "目前無要移除的潛在聯絡人。",
	ignore: "忽略",
	addAllConfirmationModal: "一個或多個用戶擁有一個個體不允許的網域。 點擊繼續將用戶新增到聯絡人列表。 網域將被匯入並新增到個體的允許網域列表中。",
	addConfirmationModal: "用戶擁有此個體不允許的網域。 點擊繼續將用戶新增到聯絡人列表。 該網域將被匯入並新增到個體的允許網域列表中。",

	// ContactDB - Message Log - Filter
	messageTypeFilter: "訊息類型",
	sentByFilter: "發送由",
	fromEntityFilter: "來自個體",
	toEntityFilter: "到個體",
	toCountryFilter: "到國家",
	toGroupRoleFilter: "到集團角色",
	toEngagementFilter: "到案件",
	toServiceLineFilter: "到服務專線",
	toRoleFilter: "到角色",

	//ContactDB - Define Attributes
	defineAttributes: "定義屬性",

	// ContactDB Edit Entity Modal
	// Step 2 - Edit Entity Modal
	addAnotherEntityAdministrator: "新增另一個個體管理員",
	editEntity: "編輯個體",
	entityAdministrators: "個體管理員（選擇性的）",
	editEntityAdministratorsInstruction: "您可以選擇新增一名或多名個體管理員。 他們可以向該個體新增聯絡人並提供對 EY Canvas Oversight 模板的訪問權限。",
	editEntityDomainInstruction: "對於外部團隊成員要訪問EY Canvas Oversight，必須具有有效的網域。系統會在設定流程的第4步中從已連接的EY Canvas任務中匯入已核准的網域。若您計劃邀請其他外部團隊成員加入該個體，請新增一個或多個網域。網域是電子郵件地址中@符號之後的字符。",
	level: "{0} 級",

	// ContactDB Remove Contacts
	removeIcon: "移除",
	removeContactTitle: "移除聯絡人",
	removeInstructionalText: "您確定要從您的計畫中刪除這些聯絡人嗎？ 若這些聯絡人屬於多個個體，那麼他們將從所有個體中被刪除。 若您需要從單一個體中刪除聯絡人，請選擇編輯他們的訪問權限。",
	removeSelectedContacts: "所選的聯絡人",

	domainNotPermitted: "此個體不允許一位或多位個體管理員的網域。",
	listView: "列表視圖",
	cardView: "卡片視圖",

	recordsNotAvailable: "記錄不可使用",

	// Project Layout Update
	welcomeLabel: "歡迎",
	activeProjectsInstructionalText: "您可以訪問此處列出的 EY Canvas Oversight 項目。 選擇一個模塊以導航至它或點選計數以查看每個項目的詳細信息。",
	otherProjectsInstructionalText: "您的 EY Canvas 參與與此處列出的 EY Canvas 監督項目相關聯。 您無權訪問這些項目。 與計畫負責人或個體管理員交談以獲得訪問權限。",
	completedProjectsInstructionalText: "您完成的 EY Canvas Oversight 項目列於此處。 選擇 <b>Roll Forward</b> 選項以在建立新項目時使用已完成的項目作為模板。",
	goToLabel: "去",
	entityAdmins: "個體管理員",
	entityAdmin: "個體管理員",
	keyContacts: "主要聯絡人",
	keyContact: "主要聯絡人",
	contactListLabel: "聯絡人列表",
	draftlabel: "草稿",
	projectWizard: "Project Wizard",
	noEntityAdminsAdded: "沒有個體管理員關聯",
	addProjectOwner: "新增計畫負責人",
	addProjectOwnerInstrText: "透過使用者的姓名或電子郵件搜尋使用者，將其新增為所選計畫的計畫負責人。",
	projectSummary: "計畫彙總",
	privacyNotice: "隱私權聲明",
	groupOversightProject: "Group Oversight project (New!)",
	groupOversightProjectTooltip: "In <b>Group Oversight projects</b>, you can identify your Primary and/or Regional EY Canvas engagement(s) for which you are creating an EY Oversight project. The Regional and/or Component EY Canvas engagement(s) identified in your EY Canvas Group structure will <b>automatically</b> be populated as part of the EY Oversight project setup. <br><br> Additionally, these types of projects will have access to a Group risk assessment module where risk assessment activities can be viewed for the Primary, Regional and/or Component engagement(s).",
	oversightProject: "Oversight project (Stat audits)",
	oversightProjectTooltip: "In Oversight projects (Stat audits), you can manually select your client(s), and then your associated EY Canvas engagement(s), for which you are creating an EY Oversight project.",

	// Group Risk Assessment
	noGroupRiskAssessmentForSelection: 'There is no Group risk assessment activity for this EY Oversight project.',
	engagementData: "Engagement data",
	engagementDetails: "Engagement details",
	reconciliations: "Reconciliations",
	nextComponent: "Next component",
	prevComponent: "Previous component",
	allAccounts: "All accounts",
	generateEmail: "Generate email",
	reconciliationDetailInstructional: "The information below summarizes the total accounts and risks related to the component team in the primary team EY Canvas group structure. Accounts and risks should be mapped to the equivalent account and risk in the component team EY Canvas engagement.",
	primaryTeamAccountName: "'Primary team account name",
	componentTeamAccountName: "Component team account name",
	designation: "Designation",
	openAccounts: "Open accounts",
	componentTeamAccounts: "Component team accounts",
	mapAccountsMessage: "Each primary team account should have at least one mapped component team account. {button} to get started.",
	primaryTeamAccountStatus: "Primary team account status",
	totalAccounts: "Total accounts",
	assessedAccounts: "Assessed accounts",
	primaryTeamRiskStatus: "Primary team risk status",
	openRisks: "Open risks",
	assessedRisks: "Assessed risks",
	totalRisks: "Total risks",
	primaryTeamRiskDesignationAndName: "Primary team risk designation and name",
	primaryTeamAccountsRelatedToRisk: "Primary team account(s) related to risk",
	componentTeamRisksAndRelatedAccounts: "Component team risks and related account(s)",
	relateRisks: "Relate risks",
	relateRisksMessage: "Each primary team account should have at least one mapped component team risk. {button} to get started.",
	pspIndexesHeader: "PSP",
	pspIndexes: "PSP index(es)",
	markAssessed: "Mark assessed",
	markReOpen: "重新打開",
	riskMarkAssessedMessage: "Review primary and component team risks that are related. Once there is a complete mapping, {button}.",
	riskMarkOpenMessage: "如果需要對已標記為已評估的風險進行更改，請{button}該風險。此風險分組將顯示在“未關聯風險”畫面中。",
	markAssessedSuccessMessage: "已成功將相關科目標記為已評估。要查看科目，請轉到已評估畫面。",
	reopenAssessedAccount: "重新打開",
	reopenAssessedAccountMessage: "如果需要對已標記為已評估的科目進行更改，請{button}該科目。該科目分組將出現在“未完成範圍”中。",
	reopenSuccessMessage: "已成功重新打開相關科目。要查看科目，請轉到未完成畫面。",
	teamAccountMappedMessage: "Review primary and component team accounts that are mapped. Once there is a complete mapping, {button}.",
	teamAccountWasPreviousAssessedMessage: 'This primary and component team account grouping was previously marked assessed but there were changes to the account(s). Review primary and component team accounts to ensure the mapping is still correct. Once complete, {button}.',
	createComment: "Create comment",
	editComment: "編輯註解",
	commentTitle: "Comment",
	createCommentInstructionalText: "輸入所選科目或風險的註解詳細資訊，然後點選“儲存”以完成。",
	editCommentInstructionalText: "編輯所選科目或風險的註解詳細資訊，然後點選“儲存”完成。",
	lastModified: "上次修改時間：",
	addComment: "Add comment",
	accountDescription: "Select Open accounts to view Primary team accounts that have not been related to Component team accounts and marked assessed. Select Assessed accounts to view Primary team accounts that have been assessed.",
	riskDescription: "選擇“未關聯風險”以查看尚未與組成個體審計團隊風險關聯並標記為已評估的主查團隊風險。選擇已評估風險以查看已評估的主查團隊風險。",
	successAssessedMessage: "相關風險已成功標記為已評估。要查看風險，請轉到已評估的畫面。",
	successReOpenMessage: "相關風險已成功重新打開。要查看風險，請轉到未完成畫面。",

	// Relate risks modal
	relateRisksModalTitle: "將組成個體審計團隊風險與主查團隊風險相關聯",
	relateRisksModalInstructionalText: "選擇下面的組成個體審計團隊風險以與所選主查團隊風險相關聯。",
	primaryRegionTeamRisk: "主查團隊風險：",
	primaryTeamRiskLabel: "主查團隊風險",
	thereIsNoDataToDisplayForThisSelection: "沒有可顯示資料，無法選擇。",
	accountAndAsssociated: "科目和關聯主要證實查核程序",
	disabledRegionComponentTeamRiskLabel: "此組成個體審計團隊風險已對應到另一個主查團隊風險。一個組成個體審計團隊風險只能對應到一個主查團隊風險。為相關的主要風險選擇“關聯風險”以取消該風險的關聯（如適用）。",
	selectOneOrMore: "選擇一個或多個",

	relateAccountsModalTitle: "將組成個體審計團隊科目與主查團隊科目相關聯",
	relateAccountName: "主查團隊科目：",
	relateAccountpspIndex: "主查團隊主要證實查核程序索引：",
	relateAccountpspIndexes: "主查團隊主要證實查核程序索引：",
	relateAccountInstructionalText: "選擇下面的組成個體審計團隊科目以與所選主查團隊科目相關聯。",
	pspIndexcountLabel: "與主查團隊/地區小組科目相關的主要證實查核程序索引",
	relateAccounts: "關聯科目",

	viewComponentTeamAccountsText: "查看組成個體審計團隊科目",
	componentTeamAccountsModalTitle: "組成個體審計團隊科目未關聯和/或不適用",
	componentTeamAccountsModalInstructionalText: "組成個體審計團隊科目應與主查團隊科目相關聯。返回相關頁面以關聯科目。如果組成個體審計團隊科目不適用於集團查核，則將該科目標記為“不適用”。",
	componentTeamAccountsModalNotApplicableInstructionalText: "不適用的組成個體審計團隊科目以這種方式標記，因為它們不適用於集團查核。如果下面錯誤地列出了某個科目，請將該科目移回“未關聯”，以便將該科目與主查團隊科目相關聯。",
	notRelatedTab: "未關聯",
	notApplicableTab: "不適用",
	unmapped: "未對應",
	unrelate: "取消關聯",
	action: "操作",
	notApplicableActionTitletip: "選擇“取消關聯”將風險移動到“未關聯”選項卡。“未關聯”的風險應與主查團隊風險相關聯。如果風險不適用於集團查核，則標記為“不適用”。",
	notRelatedActionTitletip: "選擇“不適用”將風險移至“不適用”選項卡。“不適用”的組成個體審計團隊風險不適用於集團查核。",

	higherInheritRisk: "較高固有風險",
	lowerInheritRisk: "較低固有風險",
	riskAssociated: "相關風險",
	riskAssociatedHigher: "與較高固有風險相關並導致較高固有風險的風險",

	viewComponentTeamRisks: "查看組成個體審計團隊風險",
	unmappedRisksModalTitle: "組成個體審計團隊風險不相關和/或不適用",
	unmappedRisksModalInstructional: "組成個體審計團隊風險應與主查團隊風險相關聯。返回相關頁面以關聯風險。如果組成個體審計團隊風險不適用於集團查核，則將該風險標記為“不適用”。",
	notApplicableRisksModalInstructional: "不適用的組成個體審計團隊風險以這種方式標記，因為它們不適用於集團查核。如果下面錯誤地列出了某個風險，請將該風險移回“未關聯”，以便將該風險與主查團隊風險相關聯。",
	added: "已新增",
};

export const temporaryLabels = {
	dryDock: "Drydock",
	darkMode: "暗色模式",
	dashboard: "Dashboard",
	projects: 'Projects',
	scopeStrategy: "範圍與策略",
	accountSummary: "科目彙總",
	scotSummary: "SCOT彙總",
	craSummary: "CRA彙總",
	itSummary: "IT彙總",
	SPSummary: "證實評估彙總",
	auditPlan: "查核計劃",
	conclusion: "Conclusion",
	findings: "發現",
	changesReport: "報告日後變更",
	teamMember: "團隊成員獨立性",
	archiveChecklist: "歸檔檢查表",
	enagagementmanagement: "案件管理",
	integration: "整合",
	guidedWorkflow: "Guided Workflow",
	copyrightMessage: "Copyright © <year>. All rights reserved"
};

export const createGRAProjectLabels = {
	creationInstructional: "Enter a Project name and select one Primary or Regional EY Canvas engagement from the list below to create an EY Oversight project. <br> Based on the selected engagement, the EY Canvas engagement(s) identified in the EY Canvas Group structure will automatically be populated as part of this project's setup. Click the {link} for more information regarding EY Canvas Oversight.",
	projectName: labels.projectName,
	engagements: labels.engagementsLabel,
	searchPlaceholder: "Search EY Canvas engagement name, ID, or client name",
	noAccessToEng: "You do not have access to any EY Canvas engagements.",
	noDataToDisplay: labels.noDataFound,
	save: labels.save,
	cancel: labels.cancelLabel,
	engagementsRequiredMessage: "Select at least one engagement to save.",
	userGuideLinkText: "User Guide"
};

export const deleteCommentModalLabels = {
	titleText: "刪除註解",
	instructionalText: "是否確認刪除該註解？",
	triggerText: "刪除",
	confirmLabel: "確認",
	cancelLabel: "Cancel",
	closeLabel: "Close"
}

export const gaRoleType = [{
	id: GARoleTypeId.Primary,
	label: "Primary"
},
{
	id: GARoleTypeId.Region,
	label: "Region"
},
{
	id: GARoleTypeId.Component,
	label: "Component"
}
];

export const engagementTableLabels = {
	engagementName: "案件名稱",
	clientName: labels.clientName,
	type: labels.typeLabel,
	gaRoleType
};

export const formLabels = {
	required: labels.required,
	maxLength: labels.formLengthMessage
};

export const activityLogTypes = {
	ProjectCreated: 'Project created date',
	GAComponentCreated: 'Component added',
	GAComponentRemoved: 'Component removed',
	GAComponentUnlinked: 'Component unlinked',
	AccountAdded: 'Account added',
	AccountRemoved: 'Account removed',
	AccountDesignationChanged: 'Account designation changed',
	AccountEstimateChanged: 'Account estimate changed',
	AccountExecutionTypeChanged: 'Account execution type changed',
	AssertionAssociated: 'Assertion associated',
	AssertionUnassociated: 'Assertion unassociated',
	AssertionInherentRiskChanged: 'Change in Inherent risk',
	AssertionControlRiskDesignationChanged: 'Change in Control risk designation',
	RiskCreated: 'Risk created',
	RiskRemoved: 'Risk removed',
	RiskAssociated: 'Risk associated',
	RiskUnassociated: 'Risk unassociated'
};

export const activityTableLabels = {
	sourceEngagement: 'Source engagement',
	activityType: 'Activity type',
	objectImpacted: 'Object impacted',
	relatedObjectImpacted: 'Related object impacted',
	relatedSecondaryObjectImpacted: 'Related secondary object impacted',
	activityDate: 'Activity date'
};

export const regionComponentRiskTableLabels = {
	regionComponentTeamRiskName: "組成個體審計團隊風險名稱",
	details: "詳細資訊",
};

export const riskTypes = [{
	id: '1',
	label: "顯著風險",
},
{
	id: '2',
	label: "舞弊風險",
},
{
	id: '3',
	label: "Inherent risk"
}
];

export const engagementLabels = {
	accountName: "Account / disclosure name",
	accountTypeName: "Designation",
	canvasEngagementId: "Engagement Id",
	controlRiskTypeName: "Control risk",
	engagementDescription: "Engagement name",
	inherentRiskTypeName: "Inherent risk",
	assertionName: "Assertion",
	pspIndexTitle: "PSP Index",
	riskName: "Risk name",
	riskTypeName: "Risk type",
	relatedTasks: "Related tasks",
	taskStatus: "Task status",
	controlRiskAssessment: 'Control risk assessment'
};

export const groupRiskAssessmentLabels = {
	activityFeed: labels.activityFeed,
	reconciliations: labels.reconciliations,
	lastRefreshed: labels.lastRefreshed,
	groupRiskAssessment: labels.groupRiskAssessment,
	lastRefreshedReconciliation: labels.lastRefreshedReconciliation,
	lastRefreshedActivityFeed: labels.lastRefreshedActivityFeed,
};

export const reconciliationsTableLabels = {
	show: labels.show,
	noDataToDisplay: "此表單沒有可顯示的資料。",
	unselectedEntities: "該EY Oversight案件沒有調節資料。將組成部分與主查團隊EY Canvas案件中的集團指引流中的科目相關聯，以便在此處顯示調節資料。",
	columns: {
		components: "Components",
		open: "Open",
		assessed: "Assessed",
		total: "Total"
	},
	nextComponent: labels.nextComponent,
	prevComponent: labels.prevComponent
};

export const relateAccountsTableLabels = {
	show: labels.show,
	noDataFound: labels.noDataFound,
	columns: {
		accountName: "組成個體審計團隊科目",
		pspIndexes: "主要證實查核程序索引",
	},
	nextComponent: labels.nextComponent,
	prevComponent: labels.prevComponent,
	relateAccountTableDisabledRowToolTip: "此組成個體審計團隊科目已對應到另一個主查團隊科目。一個組成個體審計團隊科目只能對應到一個主查團隊科目。為相關主要科目選擇“關聯科目”以取消該科目的關聯（如適用）。",
};

export const notRelatedAccountsTableLabels = {
	show: labels.show,
	noDataFound: labels.noDataFound,
	columns: {
		accountName: relateAccountsTableLabels.columns.accountName,
		pspIndexes: "主要證實查核程序索引",
		notRelated: {
			actionColumnName: labels.action,
			titleTip: "將科目標記為\'不適用\'會將科目移動到\'不適用\'選項卡。如果科目不適用於集團查核，則應標記為\'不適用\'。",
			actionLabel: labels.notApplicableTab
		},
		notApplicable: {
			actionColumnName: labels.action,
			titleTip: "選擇\'取消關聯\'將科目移動到“未關聯”選項卡。“未關聯”的科目應與主查團隊科目相關聯。如果科目不適用於集團查核，則應標記為“不適用”。",
			actionLabel: labels.unrelate
		}
	},
	nextComponent: labels.nextComponent,
	prevComponent: labels.prevComponent
};

export const unmappedRisksTableColumnLabels = {
	riskName: "組成個體審計團隊風險",
	actions: "操作"
};

export const AdminUserErrors = {
	userError: 'User not found.'
};

/*RBAC Errors*/
export const RbacErrors = {
	106: "You don't have the required permissions to perform this action."
};

export const Errors = {
	106: "You don't have the required permissions to perform this action.",
	107: "You don't have the required permissions to perform this action.",
	111: "You cannot delegate access to yourself.",
	112: "User not found.",
	310: "Project not found.",
	314: "The domain for one or more group administrators is not permitted for this group.",
	316: "You must be a project owner or group administrator to add team members. Speak with a project owner to gain access.",
	317: "Only internal members can be added as project owners. Following are external users: {0}. Refresh the page and try again. Contact the Help Desk if the error persists.",
	318: "The domain for {0} is not permitted for the following group: {1}",
	319: "This project has been completed by another project owner. Refresh the page and try again. Contact the Help Desk if the error persists.",
	321: "You must be a project owner to complete this action. Speak with a project owner to gain access.",
	323: "This group has been deleted by another team member. Refresh the page and try again. Contact the Help Desk if the error persists.",
	324: "You must be a project owner for this project to complete it. Refresh the page and try again. Contact the Help Desk if the error persists.",
	325: "You must be a project owner or group administrator to make these changes. Speak with a project owner to gain access.",
	326: "Complete all required fields to save this project. Refresh the page and try again. Contact the Help Desk if the error persists.",
	327: "Project already saved.",
	328: "The team member you are attempting to add is already a member of this group.  Refresh the page and try again.",
	330: "The last project owner cannot be deleted",
	331: "One or more groups have been deleted by another team member. Refresh the page and try again. Contact the Help Desk if the error persists.",
	332: "At least one project owner is required. You cannot remove yourself from this project.",
	341: "You do not have access to selected clients or engagements.",
	343: "You can only delete active and draft projects. Refresh the page and try again. Contact the Help Desk if the error persists.",
	344: "You must be a project owner to delete this project. Refresh the page and try again. Contact the Help Desk if the error persists.",
	345: "此案件已被其他團隊成員刪除。 刷新頁面並重試。若錯誤仍持續，請聯絡Help Desk。",
	346: "另一位計畫負責人或個體管理員已經審核了 {0} 的訪問權限。 請重新整理訪問紀錄並重試。",
	347: "您必須為計畫負責人或個體管理員才能在此計畫中新增或移除聯絡人。請與計畫負責人聯繫以請求訪問權限。",
	348: "您只能從您管理的個體中移除聯絡人。 以下聯絡人屬於您不是其管理員且無法移除的個體：{0}。",
	360: "您必須是該計畫的計畫負責人才能完成此操作。",
	361: "您必須是計畫負責人或個體管理員才能執行此操作。 與計畫負責人聯絡以請求訪問權限。",
	362: "您只能管理屬於您管理的個體的聯絡人的訪問權限。 以下聯絡人屬於您不是其管理員的個體，並且無法編輯他們的訪問權限：{0}。",
	364: "您正在嘗試編輯一個或多個已從此項目中刪除的聯絡人的訪問權限。 請重新整理頁面並重試。",
	365: "您正在嘗試編輯已從此計畫中刪除的一個或多個聯絡人的屬性：{0}請重新整理頁面並重試。",
	366: "您只能編輯屬於您管理的實體的聯絡人的屬性。 以下聯絡人屬於您不是其管理員的實體：{0}",
	367: "您正在編輯的自定義欄已被其他團隊成員刪除。 請重新整理頁面並重試。",
	368: "您正在編輯的自定義欄選項已被其他團隊成員刪除。請重新整理頁面並重試。",
	369: "您必須是計畫負責人才能執行此操作。",
	370: "您只能編輯屬於您管理的個體的聯絡人的屬性。 以下聯絡人屬於您不是其管理員的個體：{0}",
	372: "您必須是計畫負責人才能執行此操作。",
	373: "無法從聯絡人清單頁面刪除計畫負責人。 前往 project wizard 以執行請求。",
	374: "You cannot remove yourself as Project Owner from this project.",
	375: "You cannot remove the last Project Owner from a project. At least 1 Project Owner must remain.",
	376: 'You must be a Project owner to add/remove a Project owner or an Entity administrator from the project. The following contacts cannot be removed: {0}',
	378: 'Domain cannot be removed as it is in use by a contact on the Contact list page of this Oversight project. Go to the Contact list page and remove contact(s) with this domain, then return here to remove domain.',
	502: "Get engagements call failed. Refresh the page and try again. Contact the Help Desk if the error persists.",
	503: "You do not have access for the selected Clients.",
	601: "Get clients call failed. Refresh the page and try again. Contact the Help Desk if the error persists.",
	1605: "The selected user already exists.",

	1803: "使用無效的計畫數據執行標記操作，請重新整理頁面並重試。若錯誤仍持續，請聯絡Help Desk以獲得進一步的幫助。",
	1804: "您必須是此計畫的計畫負責人才能執行此標記操作。",
	1901: "發送訊息 API 通知失敗。",
	1902: "訊息不能為空。",
	1903: "允許的訊息長度為 200 個字符。",
	1904: "允許的通知喚回文字長度為 50 個字符。",
	1905: "允許的通知喚回 uri 長度為 50 個字符。",
	1906: "您必須至少選擇一個篩選條件才能繼續。",
	1907: "收件人不能重複。",
	1908: "案件不能為空白。",
	1909: "訊息類型不是有效值。",
	1910: "收件人不能為空白。",
	1911: "toast訊息不能為空白。",
	1912: "收件人類型不是有效值。",
	1913: "您沒有適當的訪問權限來發送通知。 與案件擁有者或個體管理員聯絡以請求訪問權限。",
	1914: "通知只能發送給內部聯絡人。 查看郵件收件人並刪除外部聯絡人以繼續。",
	2101: "目前無法使用安永政策撰寫、核准和通知服務。 我們無法確認是否已完成所有相關政策。 若您尚未複核相關政策，請重新整理頁面並重試。若錯誤仍持續，請聯絡Help Desk。",

	// Reconciliation
	2701: "獲取所有調節指令失敗。",
	2702: "無效的請求。",
	2703: "按ID獲取調節指令失敗。",
	2704: "按ID獲取風險指令失敗。",
	2705: "在資料庫中找不到案件。",
	2706: "在資料庫中找不到科目。",
	2707: "在資料庫中找不到案件。",
	2708: "建立案件註解指令失敗。",
	2709: "已建立註解。請更新頁面並重試。",
	2710: "修補集團組成部分科目指令失敗。",
	2711: "在資料庫中找不到集團組成部分科目。",
	2712: "理由註解不能為空。",
	2713: "理由註解不能超過4000個字元。",
	2714: "未找到集團組成部分風險。",
	2715: "未找到集團組成部分。",
	2718: "更新調節指令失敗",
	2720: "此項目已被其他用戶編輯或刪除。請更新並重試。",
	2721: "已建立註解。請更新頁面並重試。",
};

export const clientValidationErrors = {
	ErrorAtleastOneEngagementAssociationRequired: "Connect at least one engagement to the organizational chart to continue.",
	ErrorAtleastOneGroupAssociationRequired: "Connect at least one group to the organizational chart to continue.",
	ErrorStep2DataNotComplete: "Enter a name for each entity on the organizational chart to continue."
};

export const engagementsViewBy = [{
	id: 0,
	label: "All",
	value: "All"
},
{
	id: 1,
	label: "By country",
	value: "Country",
	groupAttributeName: 'countryName'
},
{
	id: 2,
	label: "按主要辦公室",
	value: "By region",
	groupAttributeName: 'regionName'
},
{
	id: 3,
	label: "By engagement type",
	value: "Type",
	groupAttributeName: 'profileNature'
}
];

export const milestones = [{
	id: 1,
	label: "Scope",
	auditPhaseId: 1,
	value: 1
},
{
	id: 2,
	label: "Strategy",
	auditPhaseId: 1,
	value: 2
},
{
	id: 3,
	label: "Walkthroughs",
	auditPhaseId: 2,
	value: 3
},
{
	id: 4,
	label: "Interim Control Testing",
	auditPhaseId: 2,
	value: 4
},
{
	id: 5,
	label: "Interim Substantive Testing",
	auditPhaseId: 2,
	value: 5
},
{
	id: 6,
	label: "Walkthroughs (year-end processes)",
	auditPhaseId: 2,
	value: 6
},
{
	id: 7,
	label: "Year-end Control Testing",
	auditPhaseId: 2,
	value: 7
},
{
	id: 8,
	label: "Year-end Substantive Testing",
	auditPhaseId: 2,
	value: 8
},
{
	id: 9,
	label: "Conclusion",
	auditPhaseId: 3,
	value: 9
},
{
	id: 10,
	label: "N/A",
	auditPhaseId: 2,
	value: 10
},
{
	id: 11,
	label: "Execution",
	auditPhaseId: 2,
	value: 11
},
{
	id: 12,
	label: "Scope and strategy quality activities",
	auditPhaseId: 1,
	value: 12
},
{
	id: 13,
	label: "Other scope and strategy",
	auditPhaseId: 1,
	value: 13
},
{
	id: 14,
	label: "CRA",
	auditPhaseId: 1,
	value: 14
},
{
	id: 15,
	label: "Risk Assessment and Materiality",
	auditPhaseId: 1,
	value: 15
},
{
	id: 16,
	label: "Finalize scope and strategy",
	auditPhaseId: 1,
	value: 16
},
{
	id: 17,
	label: "Post-interim project management",
	auditPhaseId: 2,
	value: 17
}
];

export const daysOptions = [{
	id: daySelection.tomorrow,
	value: daySelection.tomorrow,
	label: "Tomorrow"
},
{
	id: daySelection.next3days,
	value: daySelection.next3days,
	label: "Next 3 days"
},
{
	id: daySelection.next5days,
	value: daySelection.next5days,
	label: "Next 5 days"
},
{
	id: daySelection.next10days,
	value: daySelection.next10days,
	label: "Next 10 days"
},
{
	id: daySelection.next30days,
	value: daySelection.next30days,
	label: "Next 30 days"
}
];

export const auditPhases = [{
	id: 1,
	label: "Scope & strategy"
},
{
	id: 2,
	label: "Execution"
},
{
	id: 3,
	label: "Conclusion"
}
];

export const findings = [{
	id: 1,
	label: "Misstatements",
	subTitle: "Misstatements by type"
},
{
	id: 2,
	label: "Deficiencies",
	subTitle: "Deficiencies by severity"
}
];
export const risks = [{
	id: 1,
	label: '',
	subTitle: "By type"
}];

export const auditStrategies = [{
	id: 1,
	label: "Substantive",
	subTitle: "Substantive procedures by type"
},
{
	id: 2,
	label: "Controls",
	subTitle: "Controls by testing strategy"
},
{
	id: 3,
	label: "IT",
	subTitle: "IT procedures by testing strategy"
}
];

export const auditInsights = [{
	id: 1,
	label: "By Group role"
},
{
	id: 2,
	label: "All"
}
];

export const projectStatus = {
	Active: "active",
	Draft: "draft",
	Cancel: "cancel",
	Complete: "completed",
	Delete: "刪除"
};

export const ProjectStatusLabels = [{
	label: 'Initial',
	id: 1,
	value: 'Initial'
},
{
	label: 'Draft',
	id: 2,
	value: 'Draft'
},
{
	label: 'Active',
	id: 3,
	value: 'Active'
},
{
	label: 'Cancelled',
	id: 4,
	value: 'Cancelled'
},
{
	label: 'Completed',
	id: 5,
	value: 'Completed'
},
{
	label: "已刪除",
	id: 6,
	value: 'Delete'
}
];

export const projectTeamEngagementTableGroup = [{
	id: 1,
	label: "Preparer assignments"
},
{
	id: 2,
	label: "Reviewer assignments"
}
];

export const archiveReportQualifiedType = [{
	id: archiveReportQualifiedTypeId.notSelected,
	label: "Not selected"
},
{
	id: archiveReportQualifiedTypeId.unqualifiedWithEmphasisOfMatter,
	label: "Unqualified - With emphasis of matter"
},
{
	id: archiveReportQualifiedTypeId.unqualifiedWithoutEmphasisOfMatter,
	label: "Unqualified - Without emphasis of matter"
},
{
	id: archiveReportQualifiedTypeId.qualifiedWithEmphasisOfMatter,
	label: "Qualified - With emphasis of matter"
},
{
	id: archiveReportQualifiedTypeId.qualifiedWithoutEmphasisOfMatter,
	label: "Qualified - Without emphasis of matter"
},
{
	id: archiveReportQualifiedTypeId.adverseOpinionWithEmphasisOfMatter,
	label: "Adverse opinion - With emphasis of matter"
},
{
	id: archiveReportQualifiedTypeId.adverseOpinionWithoutEmphasisOfMatter,
	label: "Adverse opinion - Without emphasis of matter"
},
{
	id: archiveReportQualifiedTypeId.disclaimerOfOpinionWithEmphasisOfMatter,
	label: "Disclaimer of opinion - With emphasis of matter"
},
{
	id: archiveReportQualifiedTypeId.disclaimerOfOpinionWithoutEmphasisOfMatter,
	label: "Disclaimer of opinion - Without emphasis of matter"
}
];

export const strategyTableGroup = [{
	id: 1,
	label: ''
}];

export const roleForMember = [{
	id: roles.partnerInCharge,
	label: "Partner in Charge",
	roleAbbreviation: "PTR IN CHG"
},
{
	id: roles.engagementPartner,
	label: "Engagement Partner",
	roleAbbreviation: "EP"
},
{
	id: roles.executiveDirector,
	label: "Executive Director",
	roleAbbreviation: "EXEC DIR"
},
{
	id: roles.principal,
	label: "Principal",
	roleAbbreviation: "PRINCIPAL"
},
{
	id: roles.seniorManager,
	label: "Senior Manager",
	roleAbbreviation: "SR.MANAGER"
},
{
	id: roles.manager,
	label: "Manager",
	roleAbbreviation: "MANAGER"
},
{
	id: roles.senior,
	label: "Senior",
	roleAbbreviation: "SENIOR"
},
{
	id: roles.staff,
	label: "Staff",
	roleAbbreviation: "STAFF"
},
{
	id: roles.intern,
	label: "Intern",
	roleAbbreviation: "Intrn"
},
{
	id: roles.engagementQualityReviewer,
	label: "Engagement Quality Reviewer",
	roleAbbreviation: "EQR"
},
{
	id: roles.otherPartner,
	label: "Other Partner",
	roleAbbreviation: "OTHER PTR"
},
{
	id: roles.gdsStaff,
	label: "GDS - Staff",
	roleAbbreviation: "GDS-STAFF"
},
{
	id: roles.advisory,
	label: "Advisory (ITRATASHuman Capital or Other)",
	roleAbbreviation: "ADV"
},
{
	id: roles.tax,
	label: "Tax",
	roleAbbreviation: "Tax"
},
{
	id: roles.executiveSupportServices,
	label: "Executive Support Services",
	roleAbbreviation: "ESS"
},
{
	id: roles.generalCounsel,
	label: "General Counsel",
	roleAbbreviation: "GCO"
},
{
	id: roles.auditQualityReviewer,
	label: "Audit Quality Reviewer",
	roleAbbreviation: "AQR"
},
{
	id: roles.mlComponentTeam,
	label: "ML Component Team",
	roleAbbreviation: "MCT"
},
{
	id: roles.clientSupervisor,
	label: "Client Supervisor",
	roleAbbreviation: "ClntS"
},
{
	id: roles.clientStaff,
	label: "Client Staff",
	roleAbbreviation: "ClntSt"
},
{
	id: roles.internalAuditSupervisor,
	label: "Internal Audit Supervisor",
	roleAbbreviation: "IASup"
},
{
	id: roles.internalAuditStaff,
	label: "Internal Audit Staff",
	roleAbbreviation: "IASt"
},
{
	id: roles.regulator,
	label: "Regulator",
	roleAbbreviation: "Reglr"
},
{
	id: roles.other,
	label: "Other (e.g. due diligence review)",
	roleAbbreviation: "Otrs"
},
{
	id: roles.office,
	label: "Office",
	roleAbbreviation: "Off"
},
{
	id: roles.area,
	label: "Area",
	roleAbbreviation: "Area"
},
{
	id: roles.industry,
	label: "Industry",
	roleAbbreviation: "IND"
},
{
	id: roles.national,
	label: "National",
	roleAbbreviation: "NAT"
},
{
	id: roles.global,
	label: "Global",
	roleAbbreviation: "GBL"
},
{
	id: roles.gsdSenior,
	label: "GDS - Senior",
	roleAbbreviation: "GDS-SENIOR"
},
{
	id: roles.gsdManager,
	label: "GDS - Manager",
	roleAbbreviation: "GDS-MANAGER"
}
];

export const toggleCCPEntityOptions = [{
	id: toggleCCPEntityDetail.comingDue,
	label: labels.comingDue
},
{
	id: toggleCCPEntityDetail.overdue,
	label: labels.taskStatusOverdue
},
{
	id: toggleCCPEntityDetail.returned,
	label: labels.returned
}
];


export const reportReadinessSeries = [{
	id: readinessReportCategories.comingDueOver2Weeks,
	label: `> 2{break}${labels.weeks}`
},
{
	id: readinessReportCategories.comingDue12Weeks,
	label: `1-2{break}${labels.weeks}`
},
{
	id: readinessReportCategories.comingDueUnder1Week,
	label: `< 1{break}${labels.week}`
},
{
	id: readinessReportCategories.overDueUnder1Week,
	label: `< 1{break}${labels.week}`
},
{
	id: readinessReportCategories.overDue12Weeks,
	label: `1-2{break}${labels.weeks}`
},
{
	id: readinessReportCategories.overDueOver2Weeks,
	label: `> 2{break}${labels.weeks}`
}
];

export const natureOfEngagementsLabels = {
	[natureOfEngagements.auditStatements.id]: "Audit of financial statements",
	[natureOfEngagements.integratedStatements.id]: "Integrated audit of financial statements and internal control over financial reporting",
	[natureOfEngagements.reviewStatements.id]: "Review of interim financial statements",
	[natureOfEngagements.nonAuditAccount.id]: "Non-audit engagement with account/assertion/SCOT functionality",
	[natureOfEngagements.nonAuditWorkPlan.id]: "Non-audit engagement with workplan functionality only"
};

export const AdminRoles = [{
	label: 'Application admin reader',
	id: 1
},
{
	label: 'Application admin writer',
	id: 2
},
{
	label: 'Application super admin',
	id: 3
}
];

export const userType = [{
	value: 1,
	label: "內部的"
},
{
	value: 2,
	label: "外部的"
}
];

export const MessageType = [{
	value: 1,
	label: "電子郵件"
},
{
	value: 2,
	label: "通知"
}
];

export const groupRole = [{
	value: 1,
	label: "主查團隊",
	id: 1,
	selected: false,
	disabled: false
},
{
	value: 2,
	label: "區域團隊",
	id: 2,
	selected: false,
	disabled: false
}, {
	value: 3,
	label: "組成團隊",
	id: 3,
	selected: false,
	disabled: false
},
{
	value: 4,
	label: "組成團隊向非安永審計人員報告",
	id: 4,
	selected: false,
	disabled: false
},
{
	value: 5,
	label: "不適用",
	id: 5,
	selected: false,
	disabled: false
}
];

export const accessLogResource = [{
	id: 1,
	label: "要新增的聯絡人"
},
{
	id: 2,
	label: "要移除的聯絡人"
}
]

export const addContactsTabsResource = [{
	id: 1,
	label: "訪問"
},
{
	id: 2,
	label: "屬性"
},
{
	id: 3,
	label: "標籤"
}
]

export const tags = [{
	name: "審計合夥人",
	id: 'auditPartner'
},
{
	name: "審計案件經理",
	id: 'auditEngagementManager'
}, {
	name: "GDS 案件經理",
	id: 'gdsEngagementManager'
}, {
	name: "稅務合夥人",
	id: 'taxPartner'
}, {
	name: "稅務案件經理",
	id: 'taxEngagementManager'
}, {
	name: "FAIT合夥人",
	id: 'faitPartner'
}, {
	name: "FAIT案件經理",
	id: 'faitEngagementManager'
}, {
	name: "諮詢業務合夥人",
	id: 'advisoryPartner'
}, {
	name: "諮詢業務案件經理",
	id: 'advisoryEngagementManager'
}, {
	name: "專家",
	id: 'specialist'
}, {
	name: "客戶管理員",
	id: 'clientadministrator'
}
];

export const dashboardContactViews = [{
	id: dashboardTabId.milestones,
	value: dashboardViewsConstants.milestones,
	tooltipText: "按里程碑的審計進度",
	key: "里程碑",
	checked: false
},
{
	id: dashboardTabId.projectManagement,
	value: dashboardViewsConstants.projectManagement,
	tooltipText: "Status of review notes and assignments, including overdue items. External users cannot be granted access to the Project management dashboard.",
	key: "計畫管理",
	checked: false,
},
{
	id: dashboardTabId.groupAudit,
	value: dashboardViewsConstants.groupAudit,
	tooltipText: "主查和組成個體團隊狀態，包括退回和逾期的物品。",
	key: "集團查核",
	checked: false,
},
{
	id: dashboardTabId.groupRiskAssessment,
	value: dashboardViewsConstants.groupRiskAssessment,
	tooltipText: "主查和組成個體團隊的集團風險評估視圖。 客戶端無法查看此視圖。",
	key: "集團風險評估",
	checked: false,
},
{
	id: dashboardTabId.canvasClientPortal,
	value: dashboardViewsConstants.ccp,
	tooltipText: "請求狀態，包括即將到期、逾期和退回的項目。",
	key: "EY Canvas Client Portal",
	checked: false
},
{
	id: dashboardTabId.insights,
	value: dashboardViewsConstants.insights,
	tooltipText: "Comparison of risks, substantive procedures, control strategy and findings between primary and component teams. External users cannot be granted access to the Insights dashboard.",
	key: "見解",
	checked: false
},
{
	id: dashboardTabId.reporting,
	value: dashboardViewsConstants.reporting,
	tooltipText: "按國家/地區報告準備、修改和任務完成狀態。",
	key: "報告",
	checked: false
}
];

export const colorOptionsLabels = {
	red: "紅色",
	orange: "橘色",
	teal: "藍綠色",
	blue: "藍色",
	purple: "紫色",
	green: "綠色",
	yellow: "黃色",
	gray: "灰色"
};

export const exportToExcelLabels = {
	yes: 'Yes',
	no: 'No',
	exportData: labels.exportData,
	exportButtonTitle: 'Click here to download detailed client request information for the entities selected in the organization chart in the left-hand rail of this EY Oversight project.',
	projectInfo: 'Project info',
	exportDate: 'Export date',
	engagementName: labels.engagementNameLabel,
	engagementId: labels.engagementId,
	requestItemNumber: 'Request item number',
	requestTitle: 'Request title',
	priority: 'Priority',
	status: labels.status,
	receivedDate: 'Received date',
	dueDate: 'Due date',
	overdue: labels.overdueLabel,
	eyContact: 'EY contact',
	assignedTo: 'Assigned to',
	statusLabels: [{
		id: 1,
		label: 'Draft'
	},
	{
		id: 2,
		label: 'No Client Contact'
	},
	{
		id: 3,
		label: 'Sent'
	},
	{
		id: 4,
		label: 'System Error'
	},
	{
		id: 5,
		label: 'Invalid Client Contact'
	},
	{
		id: 6,
		label: 'Pending Response'
	},
	{
		id: 7,
		label: 'Received'
	},
	{
		id: 8,
		label: 'Accepted'
	},
	{
		id: 9,
		label: 'Returned'
	},
	{
		id: 10,
		label: 'Withdrawn'
	},
	{
		id: 11,
		label: 'Send In Progress'
	},
	{
		id: 12,
		label: 'Accept In Progress'
	},
	{
		id: 13,
		label: 'Withdraw In Progress'
	},
	{
		id: 14,
		label: 'Delete In Progress'
	},
	{
		id: 15,
		label: 'Return In Progress'
	},
	{
		id: 16,
		label: 'Response In Progress'
	},
	{
		id: 17,
		label: 'Deleted'
	},
	{
		id: 18,
		label: 'Invalid Client Contact Returned'
	},
	{
		id: 19,
		label: 'Recall In Progress'
	},
	{
		id: 20,
		label: 'Recalled'
	},
	{
		id: 21,
		label: 'Completion In Progress'
	},
	{
		id: 22,
		label: 'Recall In Progress'
	}
	],
	priorityTypeLabels: [{
		id: 1,
		label: 'Low'
	}, {
		id: 2,
		label: 'Medium'
	}, {
		id: 3,
		label: 'High'
	}, {
		id: 4,
		label: 'Critical'
	}],

	risks: {
		exportButtonTitle: "Click here to download detailed Risk assessment data for the entities selected in the organization chart in the left-hand rail of this EY Oversight project.",
		tabTitle: "Risk assessment details",
		columns: {
			engagementName: labels.engagementNameLabel,
			engagementId: labels.engagementId,
			accountName: "Account / disclosure name",
			pspIndex: "PSP Index",
			accountType: "Designation",
			assertion: "Assertion",
			inherentRisk: "Inherent risk",
			controlRisk: "Control risk",
			craValue: "Control risk assessment",
			riskType: "Risk type",
			riskName: "Risk name",
			relatedTasks: "Related tasks",
			taskStatus: 'Task status'
		}
	},
	exportButtonTooltip: "點選此處下載主查團隊和相關組成個體審計團隊的詳細調節資料。",
	primaryTeamEngagementName: "主查團隊案件名稱",
	componentTeamEngagementName: "組成個體審計團隊案件名稱",
	howToUseThisExport: "如何使用此匯出:",
	howToUseThisExportText: "待定-如何使用此匯出文本",
	reconciliationComponentExportTabTitle: "科目",
	reconciliationComponentExport: {
		status: "狀態",
		primaryTeamAccountName: "主查團隊科目名稱",
		componentTeamAccountNames: "組成個體審計團隊科目名稱",
		pspIndexes: "主要證實查核程序索引",
		designation: "指定",
		c: "完整性",
		eo: "存在性/發生",
		mv: "評估/衡量",
		ro: "權利與義務",
		pd: "表達與揭露",
		comment: "註解'"
	},
	groupRiskStatusLabels: {
		[groupRiskStatus.open]: "未完成",
		[groupRiskStatus.assessed]: "已評估",
		[groupRiskStatus.mapped]: "已對應",
		[groupRiskStatus.unmapped]: "未對應",
		[groupRiskStatus.notApplicable]: "不適用"
	},
	reconciliationExportTabRisks: 'Risks',
	reconciliationExport: {
		status: "狀態",
		primaryTeamRiskName: 'Primary team risk name',
		componentTeamRiskName: 'Component team risk name(s)',
		riskDesignation: 'Risk designation',
		accountsRelatedToRisk: 'Account(s) related to risk',
		c: "完整性",
		eo: "存在性/發生",
		mv: "評估/衡量",
		ro: "權利與義務",
		pd: "表達與揭露",
		comment: "註解'"
	}
};

export const accountDesignationsLabels = {
	[accountDesignations.significantAccount]: "Significant",
	[accountDesignations.limitedRiskAccount]: "Limited risk",
	[accountDesignations.insignificantAccount]: "Insignificant",
	[accountDesignations.otherAccount]: "Other",
	[accountDesignations.significantDisclosure]: "Significant disclosure"
}

export const riskDesignationsLabels = {
	[riskTypeIds.significant]: 'Significant Risk',
	[riskTypeIds.fraud]: 'Fraud Risk',
	[riskTypeIds.insignificant]: 'Insignificant Risk'
}
